/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap')

import Vue from 'vue'
import VuePapaParse from 'vue-papa-parse'
import vuetify from './plugins/vuetify'
import i18n from './plugins/i18n'
import router from './router'
import App from './App.vue'

/**
 * MUST BE AT LAST
 */
import { store } from './stores'

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
Vue.use(VuePapaParse)

const authUser = window.laravel.user
const defaultPageGroups = window.laravel.default_page_groups

store.commit('account/user', authUser)
store.commit('account/defaultPageGroups', defaultPageGroups)

new Vue({
  vuetify,
  el: '#app',
  router,
  i18n,
  store,
  render: h => h(App)
})
